/**
 * InformesApiClient -- los tres informes del dueno (INF-T4; contrato ep-informes-dueno, nexo-api PR 716 de A).
 *
 * GET /api/v1/businesses/{businessId}/informes/{egresos-por-concepto|pagos-proveedor|financiero-mensual}?...
 * La consulta la arma consultaDe (application/informes/informesDelDueno.js). Mientras la API no los sirva contesta 404:
 * NO_PUBLICADO, y la vista lo dice; cuando salgan se encienden solos, sin re-deploy del panel. Nunca lanza.
 *
 * @module infrastructure/api/InformesApiClient
 */
import { ApiBase } from './ApiBase.js';
import { INFORMES, consultaDe } from '../../application/informes/informesDelDueno.js';

export const InformesApiClient = {
  /** @returns {{ok:true, data}|{ok:false, motivo:'SIN_NEGOCIO'|'NO_PUBLICADO'|'PROHIBIDO'|'DATOS'|'SIN_RED'|'ERROR_API', detalle}} */
  async leer(businessId, clave, filtros) {
    if (!businessId) return { ok: false, motivo: 'SIN_NEGOCIO', detalle: 'elige un negocio' };
    const inf = INFORMES.find((i) => i.clave === clave);
    if (!inf) return { ok: false, motivo: 'ERROR_API', detalle: 'informe desconocido: ' + clave };
    let res;
    try {
      res = await ApiBase.get(`/api/v1/businesses/${encodeURIComponent(businessId)}/informes/${inf.ruta}?${consultaDe(clave, filtros)}`);
    } catch (err) {
      return { ok: false, motivo: 'SIN_RED', detalle: err?.message || 'no se pudo hablar con la API' };
    }
    if (!res || !res.ok) {
      const detalle = typeof res?.error === 'string' ? res.error : res?.error?.message || '';
      if (res?.code === 404) return { ok: false, motivo: 'NO_PUBLICADO', detalle: 'la API todavia no sirve los informes del dueno' };
      if (res?.code === 401 || res?.code === 403) return { ok: false, motivo: 'PROHIBIDO', detalle };
      // La API explica el 400 (fechas, rango de mas de 24 meses, falta el concepto) y el 422 (proveedorId): ese texto manda.
      if (res?.code === 400 || res?.code === 422) return { ok: false, motivo: 'DATOS', detalle };
      if (res?.code === 'NETWORK' || res?.code === 'TIMEOUT') return { ok: false, motivo: 'SIN_RED', detalle: 'no se pudo hablar con la API' };
      return { ok: false, motivo: 'ERROR_API', detalle: detalle || 'error de la API' };
    }
    return { ok: true, data: res.data?.data ?? res.data?.Data ?? res.data ?? null };
  }
};
